<template>
  <v-container grid-list-xs fluid>
    <form-dialog v-model="dialog" :title="formTitle" @input="reset">
      <v-sheet class="white py-3 px-4">
        <question-form @saved="save" ref="questionForm" v-model="question" />
      </v-sheet>
    </form-dialog>
    <!-- DATA TABLE -->
    <v-card class="layout row wrap shadow pa-3">
      <div class="flex-row justify-space-between align-center grey lighten-4">
        <v-menu offset-y>
          <strong class="title_label pl-2" slot="activator">
            <span>{{ filter.title }}</span>
          </strong>
          <v-list>
            <v-list-tile
              :key="index"
              @click="filter = item"
              v-for="(item, index) in filters"
            >
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>

        <v-spacer />
        <v-btn
          icon
          dark
          small
          class="shadow"
          color="secondary"
          :loading="loading"
          @click="dialog = true"
          v-if="can('add_questions')"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </div>
      <v-flex xs12 class="di-flex justify-space-between align-center mt-3">
        <v-text-field
          small
          outline
          single-line
          hide-details
          class="rounded"
          v-model="search"
          style="max-width:320px"
          :placeholder="$t('search')"
          prepend-inner-icon="mdi-magnify"
        />
        <v-spacer />
      </v-flex>

      <v-data-table
        :search="search"
        class="flex xs12"
        :headers="headers"
        :loading="loading"
        :items="filteredItems"
        :rows-per-page-items="per_page"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.index + 1 }}</td>
          <td>{{ props.item.pretty_section }}</td>
          <td>{{ props.item.pretty_type }}</td>
          <td @click="props.expanded = !props.expanded">
            {{ props.item.details }}
          </td>
          <td>
            <v-btn
              icon
              flat
              small
              class="ma-0 pa-0"
              color="grey darken-2"
              @click="editItem(props.item)"
              v-if="can('edit_questions')"
            >
              <v-icon>mdi-pencil-outline</v-icon>
            </v-btn>
            <v-btn
              icon
              flat
              small
              class="ma-0 pa-0"
              color="grey darken-2"
              @click="deleteItem(props.item)"
              v-if="can('delete_questions')"
            >
              <v-icon>mdi-delete-outline</v-icon>
            </v-btn>
          </td>
        </template>
        <template v-slot:expand="props">
          <v-card flat>
            <v-card-text>
              <p>
                <strong>{{ $t("mr_0") }}</strong>
                <br />
                <span>{{ props.item.mr_0 }}</span>
              </p>
              <v-divider class="py-2" />
              <p>
                <strong>{{ $t("mr_1") }}</strong>
                <br />
                <span>{{ props.item.mr_1 }}</span>
              </p>
              <v-divider class="py-2" />
              <p>
                <strong>{{ $t("mr_2") }}</strong>
                <br />
                <span>{{ props.item.mr_2 }}</span>
              </p>
              <v-divider class="py-2" />
              <p>
                <strong>{{ $t("mr_3") }}</strong>
                <br />
                <span>{{ props.item.mr_3 }}</span>
              </p>
              <v-divider class="py-2" />
              <p>
                <strong>{{ $t("mr_4") }}</strong>
                <br />
                <span>{{ props.item.mr_4 }}</span>
              </p>
              <v-divider class="py-2" />
              <p>
                <strong>{{ $t("mr_5") }}</strong>
                <br />
                <span>{{ props.item.mr_5 }}</span>
              </p>
            </v-card-text>
          </v-card>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import questionForm from "./questionForm";

export default {
  name: "question",
  components: { questionForm },
  data: () => ({
    items: [],
    search: null,
    question: {},
    dialog: false,
    editIndex: -1,
    loading: false,
    filters: [
      { title: "All Sections", value: false },
      { title: "IG&SP", value: 1 },
      { title: "PM", value: 2 },
      { title: "FM", value: 3 },
      { title: "HRM", value: 4 },
      { title: "EXT Comms", value: 5 }
    ],
    filter: { title: "All Sections", value: false }
  }),
  computed: {
    headers: vm => [
      { text: vm.$t("number"), sortable: false, width: "50px" },
      { text: vm.$t("section"), value: "pretty_section" },
      { text: vm.$t("type"), value: "pretty_type", width: "100px" },
      { text: vm.$t("question"), value: "details" },
      { text: vm.$t("actions"), sortable: false, width: "120px" }
    ],
    formTitle: vm => (vm.editIndex > -1 ? "Edit Question" : "New Question"),
    filteredItems() {
      if (this.filter.value)
        return this.items.filter(x => x.section == this.filter.value);
      else return this.items;
    }
  },

  methods: {
    reset() {
      this.question = {
        id: null,
        compulsory: false,
        pro_rated: false,
        section: "",
        details: "",
        mr_0: "",
        mr_1: "",
        mr_2: "",
        mr_3: "",
        mr_4: "",
        mr_5: ""
      };
      this.dialog = false;
      this.editIndex = -1;
      this.loading = false;
      this.$validator.reset();
    },

    save(value) {
      this.loading = true;
      if (this.editIndex < 0) this.items.push(value);
      else this.items.splice(this.editIndex, 1, value);
      this.reset();
    },

    deleteItem(item) {
      let vm = this;
      this.$alert(`/questions/${item.id}`).then(() => {
        vm.items.splice(vm.items.indexOf(item), 1);
      });
    },

    editItem(item) {
      this.question = Object.assign({}, item);
      this.editIndex = this.items.indexOf(item);
      this.dialog = true;
    }
  },
  created() {
    this.loading = true;
    this.axios
      .get("/questions")
      .then(res => {
        this.items = res.data.data;
        this.loading = false;
      })
      .catch(() => (this.loading = false));
  }
};
</script>
